import { render } from "./PricingHostingComponent.vue?vue&type=template&id=efcb0d32&scoped=true"
import script from "./PricingHostingComponent.vue?vue&type=script&lang=js"
export * from "./PricingHostingComponent.vue?vue&type=script&lang=js"

import "./PricingHostingComponent.vue?vue&type=style&index=0&id=efcb0d32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efcb0d32"]])

export default __exports__